// import { /* mutations as MUTATION, */ actions as ACTION } from "./types";
// import Api from "src/services/Api";
// import { base } from "@/services/Endpoint";
// import config from "@/app/editor/config/index";
// import getParameterByName from "@/app/utils/getParameterByName";

// type ActionArg = {
//   commit: Function;
// }
const actions = {};

export default actions;
